import { uiText } from '../i18n/uiText';
import useDraftBuffer from './useDraftBuffer';
import {useConfirm} from '../store/ConfirmContext';

// Record identity travels with its editable fields. Never restore text while
// keeping an unrelated selection/new-record flag from the current screen.
export default function useRecordFormDraft(userId, scopeId, kind, emptyForm) {
  const buffer=useDraftBuffer(userId,scopeId,kind);
  const confirm=useConfirm();
  const entry=buffer.values.editor;
  const form=entry?.form || emptyForm;
  const recordId=entry?.recordId ?? null;
  const setForm=update=>{
    const current=buffer.values.editor || {recordId:null,form:emptyForm};
    buffer.edit('editor',{...current,form:typeof update==='function'?update(current.form):update});
  };
  const begin=async(nextId,values)=>{
    if((buffer.count || buffer.recovery) && !await confirm(uiText("В форме есть несохранённые изменения. Заменить их выбранным документом?"),{title:uiText("Несохранённые изменения"),confirmLabel:uiText("Заменить форму")})) return false;
    if(!buffer.active) return false;
    buffer.discard();
    buffer.hydrate({editor:{recordId:nextId ?? null,form:values}});
    return true;
  };
  const saved=snapshot=>{
    buffer.acknowledge(snapshot,{committed:true});
    // A response from an old view must neither erase a newer edit nor change
    // the record currently displayed by a newly mounted editor.
    if(!buffer.active || buffer.count) return false;
    buffer.hydrate({editor:{recordId:null,form:emptyForm}});
    return true;
  };
  return {buffer,form,recordId,setForm,begin,saved,recoveryId:buffer.recovery?.editor?.recordId ?? null};
}
